<template>
  <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme" :class="MobileMenu.open?'active':''">
    <div class="app-brand">
      <img src="@/assets/logo.svg" alt="Profit">

      <a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto" @click.prevent="MobileMenu.toggle()">
        <i class="ti ti-x d-block d-xl-none ti-md align-middle"></i>
      </a>
    </div>

    <div class="menu-inner-shadow"></div>

    <ul class="menu-inner menu-nav py-1" v-if="menu.items">
      <li class="menu-item" v-for="(item, index) in menu.items" :key="index" :class="item.active?'active':''">
        <RouterLink :to="item.to" v-if="item.to" class="menu-link">
          <i class="menu-icon tf-icons ti" :class="item.icon"></i>
          <div>{{item.title}}</div>
        </RouterLink>
      </li>
    </ul>

    <div class="menu-bottom">
      <SidebarUser></SidebarUser>

    <div class="menu-footer">
      <ul class="menu-inner py-1">
        <li class="menu-item" v-if="isJivoEnabled">
          <a
            href="javascript:void(0);"
            class="menu-link"
            @click.prevent="openSupport"
          >
            <i class="menu-icon tf-icons ti ti-headset"></i>
            <div>Поддержка</div>
          </a>
        </li>
        <li class="menu-item">
          <a 
            :href="documentationLink" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="menu-link"
          >
            <i class="menu-icon tf-icons ti ti-book"></i>
            <div>Документация</div>
          </a>
        </li>
      </ul>
    </div>
    </div>
  </aside>
</template>

<script>

import {menu, MobileMenu} from "@/data/menu";
import {getDocLink} from "@/data/docs";
import {isJivoEnabled, openJivoChat} from "@/utils/jivo";
import SidebarUser from "@/components/page/SidebarUser.vue";

export default {
  name: "MainMenu",
  components: {SidebarUser},
  data() {
    return {
      mobileActive: false,
    }
  },
  computed: {
    MobileMenu() {
      return MobileMenu
    },
    menu() {
      return menu
    },
    isJivoEnabled() {
      return isJivoEnabled()
    },
    documentationLink() {
      return getDocLink('main')
    }
  },
  methods: {
    toggleMenu() {
      MobileMenu.open = false
    },
    openSupport() {
      openJivoChat()
    }
  }
}
</script>

<style scoped>
.layout-menu{
  transition: all 0.5s;
  overflow: hidden;
  z-index: 1090;
}

.menu-nav {
  height: auto;
  min-height: 0;
  overflow-y: auto;
  flex: 1 1 auto;
}

.menu-footer .menu-inner {
  height: auto;
  flex: 0 0 auto;
  overflow: visible;
}
.layout-menu.active{
  transform: translate3d(0, 0, 0) !important;
}
.layout-navbar-fixed body:not(.modal-open) .layout-content-navbar .layout-menu, .layout-menu-fixed body:not(.modal-open) .layout-content-navbar .layout-menu{
  z-index: 1090;
}
.app-brand img{
  height: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.menu-bottom {
  margin-top: auto;
  flex-shrink: 0;
}

.menu-footer {
  border-top: 1px solid rgba(0,0,0,0.1);
  padding-bottom: 1rem;
}
</style>